import React, { Fragment } from 'react';
import { Route } from "react-router-dom";
import { Login } from "./Login";
import { Logout } from "./Logout";
import { Callback } from "./Callback";

export var AuthsRoutes = function AuthsRoutes() {
    return React.createElement(
        Fragment,
        null,
        React.createElement(
            Route,
            { exact: true, path: "/login" },
            React.createElement(Login, null)
        ),
        React.createElement(
            Route,
            { exact: true, path: "/logout" },
            React.createElement(Logout, null)
        ),
        React.createElement(
            Route,
            { exact: true, path: "/oauth2/callback" },
            React.createElement(Callback, null)
        )
    );
};